import { setOptions, importLibrary } from '@googlemaps/js-api-loader';
var loaded = false
export const initGoogleMapsLoader = async () => {
  if (loaded) {
    return;
  }
  setOptions({
    key: GOOGLE_MAPS_API_KEY,
    version: "weekly",
    libraries: ["places"],
    language: I18n.currentLocale(),
  });
  await importLibrary("maps");
  loaded = true
}
